import { yupResolver } from "@hookform/resolvers/yup"
import CloseIcon from "@mui/icons-material/Close"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import Grid from "@mui/material/Unstable_Grid2" // Grid version 2
import React from "react"
import { FormProvider, useForm } from "react-hook-form"
import * as yup from "yup"
import { toast } from "react-toastify"
import CustomTextField from "../CustomTextField"

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { es } from "date-fns/locale"
import { Controller } from "react-hook-form"

import WarningAmberIcon from "@mui/icons-material/WarningAmber"
import { DialogTitle, IconButton } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import useMediaQuery from "@mui/material/useMediaQuery"
import { MuiFileInput } from "mui-file-input"
import { useContext } from "react"
import { useDispatch, useSelector } from "react-redux"
import { cargarAdjuntoSolicitud, solucitudActualizacionEstadoCivil } from "../../Redux/solicitudes"
import { UserAuth } from "../../context/AuthContext"
import TokenContext from "../../context/TokenContext"
import CustomSearchSelect from "../CustomSearchSelect"
import { useState } from "react"
import CustomDateField from "../CustomDateField"

const opcionesEstadoCivil = [
  { value: "", label: "Seleccione una opción" },
  { value: "100000000", label: "Casado/a" },
  { value: "100000001", label: "Soltero/a" },
  { value: "100000002", label: "Divorciado/a" },
  { value: "100000003", label: "Viudo/a" },
  { value: "100000004", label: "Concubinato" },
  { value: "100000005", label: "Separado/a" },
  { value: "100000006", label: "Unión Libre" },
]

const ModalSolicitudEstadoCivil = ({ open, handleClose }) => {
  const token = useContext(TokenContext)
  const dispatch = useDispatch()
  const theme = useTheme()
  const { empleado } = UserAuth()

  const estadoSolicitudEstadoCivil = useSelector((store) => store.solicitudes.estadoSolicitudEstadoCivil);

  const [selectedFiles, setSelectedFiles] = useState([])

  const fullScreen = useMediaQuery(theme.breakpoints.down("md"))

  const changeHandler = (newFile) => {
    setSelectedFiles(newFile)
  }

  const defaultValues = {
    empleado: empleado.empleadoid,
    asunto: "",
    fechaSolicitud: "",
    nuevoEstadoCivil: null,
  }

  const validacionSchema = yup.object().shape({
    asunto: yup.string().required("Required"),
    fechaSolicitud: yup.string().required("Required"),
    nuevoEstadoCivil: yup.object().required("Required"),
  })

  const methods = useForm({
    shouldUnregister: false,
    defaultValues,
    resolver: yupResolver(validacionSchema),
    mode: "onChange",
    shouldFocusError: true,
  })

  const { handleSubmit, trigger, setValue } = methods

  const submitDatos = (datos) => {
    const formData = new FormData()
    for (let index = 0; index < selectedFiles.length; index++) {
      if (selectedFiles[index].size >= 15000000) {
        toast.error("El archivo no puede superar los 15 megas", {
          theme: "dark",
          position: "top-center",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
        setSelectedFiles([])
        return
      }
      let element = selectedFiles[index]
      formData.append(`body${index}`, element)
    }
    dispatch(solucitudActualizacionEstadoCivil(token, datos))
    .then((id) => {
      handleClose()
      if(selectedFiles.length > 0 && id.length > 0){
        dispatch(cargarAdjuntoSolicitud(token, formData, id, 'estadoCivil_id'))
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  }


  return (
    <Dialog fullScreen={fullScreen} open={open} onClose={handleClose} aria-labelledby="responsive-dialog-title">
      <DialogTitle sx={{ m: 1, p: 1 }}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
            "&:hover": {
              color: "red",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <FormProvider {...methods}>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                name="asunto"
                label="Asunto"
                rules={{ required: "Required!" }}
                helperText="Por favor indica el asunto."
                req={true}
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mt: 2 }}>
              <CustomDateField
                name="fechaSolicitud"
                label="Fecha de solicitud:"
                rules={{ required: "Required!" }}
                helperText="Indica la fecha de solicitud"
                req={true}
                className="custom-helper"
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomSearchSelect
                options={opcionesEstadoCivil}
                req="true"
                type="text"
                name="nuevoEstadoCivil"
                lab="Nuevo estado civil"
                helperText="El estado civil es requerido"
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mt: 2 }}>
              <MuiFileInput value={selectedFiles} multiple label="Adjuntar documento" onChange={changeHandler} fullWidth />
            </Grid>
            <Grid sx={{ px: 2, mb: 2 }}>
              <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Box sx={{ height: "100%" }}>
                  <WarningAmberIcon color="warning" sx={{ mr: 1 }} />
                </Box>
                <Box sx={{ height: "100%" }}>
                  <Typography>El tamaño máximo permitido por archivo es de 15 MB</Typography>
                </Box>
              </Box>
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                // sx={buttonSx}
                disabled={estadoSolicitudEstadoCivil === "LOADING"}
                onClick={handleSubmit(submitDatos)}
              >
                Enviar
              </Button>
            </Grid>
          </FormProvider>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default ModalSolicitudEstadoCivil
